import React from 'react';
export function Footer() {
  return <footer className="bg-transparent py-10 sm:py-16 border-t border-gray-900" data-id="element-81">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-82">
        <div className="mb-6 sm:mb-8" data-id="element-83">
          <span className="text-[#E8C547] font-bold text-xl sm:text-3xl tracking-tight drop-shadow-[0_0_8px_rgba(212,168,67,0.4)]" data-id="element-84">
            KitLenguayLiteratura
          </span>
        </div>
        <p className="text-gray-500 text-sm sm:text-base mb-4 font-medium" data-id="element-85">
          © 2026 KIT COMPLETO LENGUA Y LITERATURA LISTA ™
        </p>
        <div className="flex justify-center space-x-6 text-sm sm:text-base font-medium text-gray-600" data-id="element-86">
          <span className="cursor-pointer hover:text-[#E8C547] transition-colors" data-id="element-87">
            Términos
          </span>
          <span className="cursor-pointer hover:text-[#E8C547] transition-colors" data-id="element-88">
            Privacidad
          </span>
          <span className="cursor-pointer hover:text-[#E8C547] transition-colors" data-id="element-89">
            Soporte
          </span>
        </div>
      </div>
    </footer>;
}